import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	resetGetwalletownerconfigurationlist,
	getwalletownerconfigurationlistReq
} from "../../redux/actions/getwalletownerconfigurationlistAction";

import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function Configuration() {
	const navigate = useHistory();
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(false);
	const [role, setRole] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [getViewCongigurationResArray, setGetViewCongigurationResArray] =
		useState("");
	const [getwalletownerconfigListStatus, setGetwalletownerconfigListStatus] =
		useState(false);
	const [getwalletownerconfigListArray, setGetwalletownerconfigListArray] =
		useState("");

	const dispatch = useDispatch();
	const handleChange = ({ target: { name, value } }) => {
		if (name === "role") {
			setRole(value == "Select Role" ? "" : value);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getWalletRolesRes = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	//getwalletownerconfigurationlist

	const getwalletownerconfigurationlistRes = useSelector(
		({ getwalletownerconfigurationlist }) => getwalletownerconfigurationlist
	);

	// console.log(
	// 	"getwalletownerconfigurationlistRes",
	// 	getwalletownerconfigurationlistRes
	// );
	// console.log(
	// 	"getwalletownerconfigurationlistRes",
	// 	getwalletownerconfigurationlistRes
	// );

	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getConfigurationListApi = () => {
		setGetwalletownerconfigListStatus(true);
		setIsLoading(true);
		const getwalletownerconfigurationlistReqs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				role: role
			}
		};
		return dispatch(
			getwalletownerconfigurationlistReq(
				getwalletownerconfigurationlistReqs,
				authToken
			)
		);
	};

	useEffect(() => {
		if (getwalletownerconfigListStatus) {
			if (getwalletownerconfigurationlistRes.data.status == "Success") {
				setGetwalletownerconfigListArray(
					[].concat(getwalletownerconfigurationlistRes.data.walletRolesList)
				);
				setIsLoading(false);
			}
			if (getwalletownerconfigurationlistRes.data.status == "failed") {
				setGetwalletownerconfigListArray(
					getwalletownerconfigurationlistRes.data
				);
				setIsLoading(false);
				if (
					getwalletownerconfigurationlistRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getwalletownerconfigurationlistRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [getwalletownerconfigurationlistRes.data.status]);

	// useEffect(() => {
	//   getConfigurationListApi();
	// }, []);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getConfigurationListApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getwalletownerconfigListStatus) {
			if (getwalletownerconfigurationlistRes.data.status == "Success") {
				setGetwalletownerconfigListArray(
					[].concat(getwalletownerconfigurationlistRes.data.walletRolesList1)
				);
				setIsLoading(false);
			}
		}
	}, [getwalletownerconfigurationlistRes.data.status]);

	const viewHandleClickOpen = (id) => {
		navigate.push({
			pathname: `/index/getViewConfigurationList`,
			search: `?userId=${id}`
		});
	};

	const updateEditHandleClick = (id) => {
		navigate.push({
			pathname: `/index/getEditConfigurationList`,
			search: `?userId=${id}`
		});
	};

	// const addNotificationHandleClick = (id) => {
	// 	navigate.push({
	// 		pathname: `/index/addNotification`,
	// 		search: `?userId=${id}`
	// 	});
	// };

	return (
		<Layout>
			<Card>
				{/* <BackButton /> */}
				<Grid
					container
					style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
				>
					<Grid item md={3} sm={12} xs={12} lg={3}>
						<NavLink to="/index/AddNewConfiguration">
							<CustomButton
								style={{
									padding: "8px"
								}}
							>
								Add New Configuration
							</CustomButton>
						</NavLink>
					</Grid>
					<Grid item md={3} sm={12} xs={12} lg={3}>
						<NavLink to="/index/getCommonCongigurationList">
							<CustomButton
								style={{
									padding: "8px"
								}}
							>
								Common Configuration
							</CustomButton>
						</NavLink>
					</Grid>
					<Grid item md={3} sm={12} xs={12} lg={3}>
						<NavLink to="/index/addNotification">
							<CustomButton
								style={{
									padding: "8px"
								}}
							>
								Add Notification
							</CustomButton>
						</NavLink>
					</Grid>
				</Grid>
				<Grid
					container
					spacing={2}
					style={{ padding: "25px", marginTop: "2rem" }}
				>
					<Grid item xs={12} sm={12} md={4} lg={4}>
						<TextField
							select
							size="small"
							color="primary"
							// autoFocus={true}
							type="text"
							label="Role"
							fullWidth={true}
							name="role"
							defaultValue={"Select Role" || role}
							onChange={handleChange}
							variant="standard"
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						>
							<MenuItem value="Select Role" selected="Select Role">
								Select Role
							</MenuItem>
							{getWalletRolesRes.success &&
								getWalletRolesRes.data.rolesList.map((x) => (
									<MenuItem value={x}>{x}</MenuItem>
								))}
						</TextField>
					</Grid>

					<Grid item xs={12} sm={12} md={4} lg={4} container>
						<Grid>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getConfigurationListApi}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Grid>
			</Card>

			{isLoading ? (
				<LoadingSpinner />
			) : getwalletownerconfigListArray.length == undefined ||
				!getwalletownerconfigListStatus ? (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Configuration
							</Typography>
						</Grid>

						<Grid xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="my-3 tableHeaderColor"
								variant="secondary"
								style={{ color: "white" }}
							>
								No Records Found!
							</Alert>
						</Grid>
					</Grid>
				</Card>
			) : (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Configuration
							</Typography>
						</Grid>
						<TableContainer component={Paper} className="my-3">
							<Table
								className={classes.table}
								size="small"
								aria-label="a dense table"
							>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Role
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Action
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getwalletownerconfigListArray &&
										[]
											.concat(getwalletownerconfigListArray)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">{row.role}</TableCell>

													<TableCell
														align="center"
													// style={{ display: "flex" }}
													>
														<Tooltip title="View">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => viewHandleClickOpen(row.role)}
															>
																{
																	<VisibilityIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
														</Tooltip>

														<Tooltip title="Edit">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	updateEditHandleClick(row.role, "Edit")
																}
															>
																{
																	<EditIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
														</Tooltip>
													</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
							<TablePagination
								rowsPerPageOptions={[5, 10, 25]}
								component="div"
								count={getwalletownerconfigListArray.length}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
						</TableContainer>
					</Grid>
				</Card>
			)}
		</Layout>
	);
}

export default Configuration;
